import { useAtom } from '@reatom/npm-react'

import { scanQrOpenAtom } from '../atoms'

import { ScanScreen } from './scan-screen'

export const ScanScreenController = () => {
  const [open] = useAtom(scanQrOpenAtom)

  if (!open) {
    return undefined
  }

  return <ScanScreen />
}
